import { Phone } from "lucide-react";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import { useSite, telLink, waLink } from "@/context/SiteContext";

export default function FloatingButtons() {
  const s = useSite();
  return (
    <>
      <a href={waLink(s)} target="_blank" rel="noreferrer" data-testid="floating-whatsapp-btn"
        className="fixed bottom-6 right-5 z-50 bg-whatsapp text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-transform flex items-center justify-center"
        aria-label="Book on WhatsApp">
        <WhatsAppIcon className="w-7 h-7" />
      </a>
      <a href={telLink(s)} data-testid="floating-call-btn"
        className="fixed bottom-6 left-5 z-50 bg-navy text-white px-5 py-3.5 rounded-full shadow-2xl hover:scale-105 transition-transform flex items-center gap-2 text-sm font-semibold border border-brand-sky/30"
        aria-label="Call now">
        <Phone className="w-4 h-4" /> <span className="hidden sm:inline">Call Now</span>
      </a>
    </>
  );
}
